<template>
  <div id="app">
    <div class="wrapper" v-if="this.$store.state.loggedIn">    
      <va-navibar></va-navibar>
      <va-slider :slideMenuItems="slideMenuItems"></va-slider>
      <va-content-wrap></va-content-wrap>
      <Modal></Modal>    
    </div>
    <login v-else ></login>
  </div>
</template>

<script>
import VANaviBar from 'NaviBar.vue'
import VASlider from 'Slider.vue'
import VAContentWrap from 'ContentWrap.vue'
import Modal from './components/Modal.vue'
import store from './vuex/store.js'
import slideMenuItems from './lib/slideMenuItems.js'

import login from 'comman/login.vue'

export default {
  name: 'app',
  data () {
    return {
      slideMenuItems: slideMenuItems,
      error: null
    }
  },
  created () {
    if (localStorage.token) {
      this.$axios
        .get('settings', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          this.$store.state.settingRecord = data
          // Vue.prototype.$settingRecord = 'tttttttttth'
          // alert(this.$settingRecord)
          // if (this.getRecord.logo != null) {
          //   this.logo = this.$store.state.imageBaseUrl + 'logo/' + this.getRecord.logo
          //   if (this.getRecord.favicon != null) {
          //     this.favicon = this.$store.state.imageBaseUrl + 'favicon/' + this.getRecord.favicon
          //   }
          // } else {
          //   alert('hello')
          // }
        })
        .catch(function (error) {
          console.log(error)
        })
      // check if valid token
      this.$axios.get('/auth/getuser', { headers: {'Authorization': 'Bearer ' + localStorage.token} }).then(response => response.data).then(data => {
        // console.log(data)
        this.$store.state.user = data.user
        this.$store.state.currentUser = data.user
        this.$store.state.permissions = data.permissions
        this.$store.state.profile = data.profile
        this.$store.state.loggedIn = true
        this.$store.state.api_token = localStorage.token
        localStorage.permissions = data.permissions // set permissions in local storage memory
        localStorage.user = JSON.stringify(data.user)
        // console.log('=============')
        // console.log(localStorage.user.name)
        // window.location.reload()
      }).catch(function (error) {
        // ====== If token not matched then remove token and logout user =======
        this.$store.state.user = {}
        this.$store.state.loggedIn = false
        if (localStorage.user) {
          localStorage.removeItem('user')
        }
        if (localStorage.token) {
          localStorage.removeItem('token')
        }
        if (localStorage.permissions) {
          localStorage.removeItem('permissions')
        }
        this.$axios.get('/auth/logout', { headers: {'Authorization': 'Bearer ' + localStorage.token} }).then(response => response.data).then(data => {
          console.log(data)
        })
        // =============
        this.error = error.response.data
        this.$router.push({'path': '/login'})
      }.bind(this))
    } else {
      this.$store.state.loggedIn = false
      this.$router.push({'path': '/login'})
    }
  },
  mounted () {
    if (this.$route.name === 'login') {
      this.$store.state.loggedIn = false
    }
    if (!localStorage.token) {
      this.$store.state.loggedIn = false
    }
  },
  beforeMount () {},
  components: {
    'login': login,
    'va-navibar': VANaviBar,
    'va-slider': VASlider,
    'va-content-wrap': VAContentWrap,
    Modal
  },
  store
}
</script>



// WEBPACK FOOTER //
// App.vue?54f70dec